import { useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMovieSearch } from '../hooks/useMovies'
import MovieGrid from '../components/movie/MovieGrid'
import './Search.css'

function Search() {
  const navigate = useNavigate()
  const { query, setQuery, results, loading, search, hasMore, loadMore } = useMovieSearch()
  const [searchInput, setSearchInput] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()
    if (searchInput.trim()) {
      setQuery(searchInput)
      search(searchInput)
    }
  }

  const handleMovieClick = (movie) => {
    navigate(`/movie/${movie.id}`)
  }

  return (
    <div className="page search-page">
      <div className="container">
        <div className="page-header">
          <h1 className="page-title">🔍 Buscar películas</h1>
          <p className="text-secondary">Encuentra cualquier película y agrégala a tu historial</p>
        </div>

        <form className="search-form" onSubmit={handleSubmit}>
          <div className="search-input-container">
            <svg className="search-form-icon" viewBox="0 0 24 24" width="24" height="24">
              <path fill="currentColor" d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
            <input
              type="text"
              className="search-form-input"
              placeholder="Buscar por título..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <button type="submit" className="btn btn-primary">
              Buscar
            </button>
          </div>
        </form>

        {query && (
          <div className="search-results-info">
            <p>Resultados para: <strong>"{query}"</strong></p>
          </div>
        )}

        <MovieGrid 
          movies={results}
          loading={loading}
          emptyMessage={query ? "No se encontraron películas" : "Escribe algo para buscar"}
        />

        {hasMore && results.length > 0 && (
          <div className="load-more">
            <button 
              className="btn btn-secondary"
              onClick={loadMore}
              disabled={loading}
            >
              {loading ? 'Cargando...' : 'Cargar más'}
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default Search
